import script from "./Season.vue?vue&type=script&lang=ts&setup=true"
export * from "./Season.vue?vue&type=script&lang=ts&setup=true"

import "./Season.vue?vue&type=style&index=0&id=37c2af5c&scoped=true&lang=css"

import exportComponent from "/Users/barry/www/my/www/bi/portal-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c2af5c"]])

export default __exports__